import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IBrandCart) {
    (function(State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        /**
     * The brand cart is part of the currently active cart of the retailer and IS NOT saved for later.
     */ State["ACTIVE"] = "ACTIVE";
        /**
     * The brand cart is part of the currently active cart of the retailer and IS saved for later.
     */ State["SAVED_FOR_LATER"] = "SAVED_FOR_LATER";
        /**
     * The brand cart has been checked out.
     */ State["CHECKED_OUT"] = "CHECKED_OUT";
    })(IBrandCart.State || (IBrandCart.State = {}));
    IBrandCart.build = function(partial) {
        return _object_spread({
            items: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IBrandCart || (IBrandCart = {}));
export var IBrandCart;
